// import { combineReducers } from 'redux';
import orderSummaryReducer from './orderSummary/orderSummaryReducer';
import productSummaryReducer from './productSummary/productSummaryReducer';
import profileReducer from './profile/profileReducer';

const overviewReducer = {
    profileReducer,
    orderSummaryReducer,
    productSummaryReducer,
};

export default overviewReducer;
